import React, { useEffect, useState } from "react";
import { db } from "../../firebase";
import {
    doc,
    getDoc,
    setDoc,
    updateDoc,
    collection,
    onSnapshot,
    serverTimestamp,
    query,
    where
} from "firebase/firestore";
import { toast } from "react-toastify";
import Header from "../../components/Header/Header";

// Helper for generating initial 24h slots
const generateSlotsObject = () => {
    const slots: any = {};
    for (let hour = 9; hour <= 22; hour++) {
        for (let min of [0, 30]) {
            // Logic to stop exactly at 22:00 (10:00 PM)
            if (hour === 22 && min === 30) break;

            const h = hour.toString().padStart(2, "0");
            const m = min.toString().padStart(2, "0");
            slots[`${h}:${m}`] = { number: null, updatedAt: null };
        }
    }
    return slots;
};

// Helper for AM/PM display
const formatToAMPM = (time24: string) => {
    const [hourStr, minute] = time24.split(":");
    let hour = parseInt(hourStr, 10);
    const period = hour >= 12 ? "PM" : "AM";
    hour = hour % 12 || 12;
    return `${hour}:${minute} ${period}`;
};

// Generate list of time slots for the dropdown
const timeSlots = (() => {
    const slots: string[] = [];
    // Start at 9 (9 AM) and go up to 22 (10 PM)
    for (let hour = 9; hour <= 22; hour++) {
        for (let min of ["00", "30"]) {
            // Stop at 22:00 (10:00 PM) and don't include 22:30
            if (hour === 22 && min === "30") break;

            const h = hour.toString().padStart(2, "0");
            const m = min.toString().padStart(2, "0");
            slots.push(`${h}:${m}`);
        }
    }
    return slots;
})();

const Admin: React.FC = () => {
    const [lotteries, setLotteries] = useState<{ id: string, name: string }[]>([]);
    const [selectedLottery, setSelectedLottery] = useState("");
    const [time, setTime] = useState("");
    const [number, setNumber] = useState("");
    const [loading, setLoading] = useState(false);
    const [currentDayData, setCurrentDayData] = useState<any>(null);

    // const today = new Date();
    // const todayDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
    const [selectedDate, setSelectedDate] = useState(() => {
        const today = new Date();
        return `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
    });

    // 1. Fetch Lottery Names for Dropdown
    useEffect(() => {
        const q = query(
            collection(db, "lotteryNames"), 
            where("isActive", "==", true)
        );

        const unsubscribe = onSnapshot(q, (snap) => {
            const list = snap.docs.map(d => ({ id: d.id, name: d.data().name }));
            setLotteries(list);
            if (list.length > 0 && !selectedLottery) setSelectedLottery(list[0].id);
        });
        return () => unsubscribe();
    }, [selectedLottery]);

    useEffect(() => {
        if (!selectedLottery) return;

        const dateDocRef = doc(db, "lotteryResults", selectedLottery, "dates", selectedDate);
        
        const unsubscribe = onSnapshot(dateDocRef, (docSnap) => {
            if (docSnap.exists()) {
                const data = docSnap.data();
                setCurrentDayData(data);
                // If the user has a time selected, show that slot's number immediately
                // if (time && data.slots?.[time]) {
                //     setNumber(data.slots[time].number?.toString() || "");
                // }
            } else {
                setCurrentDayData(null);
                // setNumber("");
            }
        });

        return () => unsubscribe();
    }, [selectedLottery, selectedDate]);

    useEffect(() => {
        if (currentDayData && currentDayData.slots?.[time]) {
            const existingNum = currentDayData.slots[time].number;
            setNumber(existingNum !== null ? existingNum.toString() : "");
        } else {
            setNumber("");
        }
    }, [time, currentDayData]);

    // useEffect(()=>{
    //     generateDummyData();
    // },[])


    // //to make a dummy entries
    // const generateDummyData = async (lotteryId: string = "9RncLVkQvA6TpLsPwS9P") => {
    //     if (!lotteryId) return toast.error("Select a lottery first");
        
    //     const years = [2026]; // Adjust if you need 2025
    //     const months = [1]; // 0 = Jan, 1 = Feb
        
    //     try {
    //         toast.info("Starting dummy data generation...");

    //         for (const year of years) {
    //             for (const month of months) {
    //                 // Get number of days in the month
    //                 const daysInMonth = new Date(year, month + 1, 0).getDate();

    //                 for (let day = 1; day <= daysInMonth; day++) {
    //                     const formattedDay = String(day).padStart(2, "0");
    //                     const formattedMonth = String(month + 1).padStart(2, "0");
    //                     const dateStr = `${year}-${formattedMonth}-${formattedDay}`;

    //                     const dateDocRef = doc(db, "lotteryResults", lotteryId, "dates", dateStr);

    //                     // Generate slots with random numbers (1-99)
    //                     const dummySlots: any = {};
    //                     // Using your logic: 9 AM to 10 PM
    //                     for (let hour = 9; hour <= 22; hour++) {
    //                         for (let min of ["00", "30"]) {
    //                             if (hour === 22 && min === "30") break;
                                
    //                             const timeKey = `${hour.toString().padStart(2, "0")}:${min}`;
    //                             dummySlots[timeKey] = {
    //                                 number: Math.floor(Math.random() * 100), // Random number 0-99
    //                                 updatedAt: new Date()
    //                             };
    //                         }
    //                     }

    //                     // Save to Firestore
    //                     await setDoc(dateDocRef, {
    //                         date: dateStr,
    //                         slots: dummySlots,
    //                         createdAt: new Date(),
    //                         isDummy: true // Useful for identifying/deleting later
    //                     });
    //                 }
    //             }
    //         }
    //         toast.success("Dummy data for Jan & Feb created!");
    //     } catch (error) {
    //         console.error(error);
    //         toast.error("Failed to generate dummy data");
    //     }
    // };

    // 2. Set default time to closest previous slot
    useEffect(() => {
        const now = new Date();
        const currentMinutes = now.getHours() * 60 + now.getMinutes();
        let selected = timeSlots[0];
        let closestDiff = Infinity;

        timeSlots.forEach((slot) => {
            const [hour, minute] = slot.split(":").map(Number);
            const slotMinutes = hour * 60 + minute;
            if (slotMinutes <= currentMinutes) {
                const diff = currentMinutes - slotMinutes;
                if (diff < closestDiff) {
                    closestDiff = diff;
                    selected = slot;
                }
            }
        });
        setTime(selected);
    }, []);

    const handleSubmit = async () => {
        if (!selectedLottery || !time || !number) {
            toast.error("Please fill all fields");
            return;
        }

        try {
            setLoading(true);
            
            // Path: lotteryResults > [LotteryDoc] > dates > [DateDoc]
            const lotteryRef = doc(db, "lotteryResults", selectedLottery);
            const dateDocRef = doc(collection(lotteryRef, "dates"), selectedDate);

            const docSnap = await getDoc(dateDocRef);

            // Create Date Document if it doesn't exist
            if (!docSnap.exists()) {
                await setDoc(dateDocRef, {
                    date: selectedDate,
                    slots: generateSlotsObject(),
                    createdAt: serverTimestamp(),
                });
            }

            // Update only the specific slot
            await updateDoc(dateDocRef, {
                [`slots.${time}.number`]: Number(number),
                [`slots.${time}.updatedAt`]: serverTimestamp(),
            });

            toast.success("Result added successfully!");
            setNumber("");

        } catch (error) {
            console.error(error);
            toast.error("Failed to save result");
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async () => {
        if (!window.confirm(`Are you sure you want to delete the entry for ${formatToAMPM(time)}?`)) return;

        try {
            setLoading(true);
            const dateDocRef = doc(db, "lotteryResults", selectedLottery, "dates", selectedDate);
            
            await updateDoc(dateDocRef, {
                [`slots.${time}.number`]: null,
                [`slots.${time}.updatedAt`]: serverTimestamp(),
            });

            setNumber("");
            toast.info("Entry reset to null");
        } catch (error) {
            toast.error("Failed to delete entry");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="h-[100dvh] bg-gray-100 flex justify-center items-center p-2">

      {/* Big Main Card */}
            <div className="w-full max-w-3xl bg-[#fffcf9] border border-black rounded-2xl shadow-lg p-3 flex flex-col h-full max-h-[95vh] overflow-hidden">
                <Header 
                    isShowLogout={true} 
                    // buttonTitle="Manage Lotteries"
                    // targetPath="/manage-lotteries"
                />
                <div className="flex flex-col my-auto">
                    <h1 className="text-xl font-bold text-center text-[#fa3815] mb-4">
                        Update Lottery Results
                    </h1>
                    <div className="space-y-4">
                        {/* Lottery Selection */}

                        {lotteries.length === 1 ? (
                            /* Only one lottery: Show disabled input */
                            <div>
                                <label className="text-xs font-bold text-black ml-2">LOTTERY NAME</label>
                                <input
                                    type="text"
                                    value={lotteries[0].name}
                                    readOnly
                                    disabled
                                    className="w-full border rounded-full px-3 py-2 bg-gray-50 text-black cursor-not-allowed"
                                />
                            </div>
                        ) : (
                            <div>
                                <label className="text-xs font-bold text-black ml-2">SELECT LOTTERY</label>
                                <select
                                    value={selectedLottery}
                                    onChange={(e) => setSelectedLottery(e.target.value)}
                                    className="w-full border rounded-full px-3 py-2 bg-white"
                                >
                                    {lotteries.map((l) => (
                                        <option key={l.id} value={l.id}>{l.name}</option>
                                    ))}
                                </select>
                            </div>
                        )}
                        <div className="grid grid-cols-2 gap-3">
                            {/* Fixed Date */}
                            <div>
                                <label className="text-xs font-bold text-black ml-2">DATE</label>
                                <input
                                    type="date"
                                    value={selectedDate}
                                    // readOnly
                                    onChange={(e) => setSelectedDate(e.target.value)}
                                    className="w-full border rounded-full px-3 py-2 bg-white text-black"
                                />
                            </div>

                            {/* Time Slot */}
                            <div>
                                <label className="text-xs font-bold text-black ml-2">TIME SLOT</label>
                                <select
                                    value={time}
                                    onChange={(e) => setTime(e.target.value)}
                                    className="w-full border rounded-full px-3 py-2 bg-white"
                                >
                                    {timeSlots.map((slot) => (
                                        <option key={slot} value={slot}>{formatToAMPM(slot)}</option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        {/* Result Number */}
                        <div>
                            <label className="text-xs font-bold text-black ml-2">RESULT NUMBER</label>
                            <input
                                type="number"
                                placeholder="Enter number"
                                value={number}
                                onChange={(e) => setNumber(e.target.value)}
                                className="w-full border rounded-full px-3 py-2"
                            />
                        </div>
                        <div className="flex flex-row gap-3 pt-2">
                            {/* Action Button */}
                            <button
                                onClick={handleSubmit}
                                disabled={loading}
                                className="flex-1 bg-[#fa3815] hover:bg-[#fa3815]/50 hover:text-black text-white py-2 rounded-full font-bold shadow-md transition-all active:scale-95 disabled:opacity-50"
                            >
                                {loading ? "Saving..." : "Update Result"}
                            </button>

                            {currentDayData?.slots?.[time]?.number !== null && (
                                <button
                                    onClick={handleDelete}
                                    disabled={loading}
                                    className="flex-1 border border-red-600 text-red-600 py-2 rounded-full font-bold hover:bg-red-50 transition-colors"
                                >
                                    Delete Entry
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Admin;